import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import TextItem from "../../../elements/V2/TextItem"

const StoryblokTextItem = ({
  blok,
}: Storyblok.BlokProps<Storyblok.TextItem>) => {
  return (
    <TextItem
      text={blok.text}
      hideIcon={blok.hideIcon}
      size="body-md"
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokTextItem
